import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { GearManagementService } from "../../../../../../../services/gear-management.service";
import { AppConfig } from "../../../../../../../app.config";
import { MessageService } from "primeng/api";
import { ConfirmationService } from "primeng/api";
import {
  AngularEditorConfig,
  AngularEditorToolbarComponent,
  AngularEditorComponent,
  AngularEditorService
} from "@kolkov/angular-editor";

@Component({
  selector: "app-gear-type-advice",
  templateUrl: "./gear-type-advice.component.html",
  styleUrls: ["./gear-type-advice.component.scss"],
  providers: [MessageService]
})
export class GearTypeAdviceComponent implements OnInit {
  @ViewChild("contentEditor") contentEditor: any;
  public advice: any = {};
  public gearTypes: any = [];
  public languages: any = [
    { value: "EN", label: "English" },
    { value: "ES", label: "Spanish" }
  ];
  public bikeTypes: any = [];
  public busy = false;
  public saving = false;
  public editorConfig: AngularEditorConfig = {
    spellcheck: false,
    editable: true,
    height: "auto",
    minHeight: "300px",
    maxHeight: "500px",
    width: "auto",
    minWidth: "0",
    enableToolbar: true,
    showToolbar: true,
    defaultParagraphSeparator: "",
    defaultFontName: "Nunito Sans",
    defaultFontSize: "16",
    sanitize: false,
    uploadUrl: this.appConfig.getWYSIWYGUploadURL()
  };
  public base64File: string = null;
  public headerImageURL: string = "";
  public loading: false;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public gearManagementService: GearManagementService,
    public messageService: MessageService,
    public appConfig: AppConfig
  ) {
    this.gearManagementService.getBikeTypes().subscribe(bikeTypes => {
      this.bikeTypes = bikeTypes.map(x => {
        return { value: x.id, label: x.description };
      });
    });
  }

  getGearTypes(BikeTypeID) {
    this.gearManagementService.getGearTypes(BikeTypeID).subscribe(gearTypes => {
      this.gearTypes = gearTypes.map(x => {
        return { value: x.gearTypeID, label: x.gearType };
      });
    });
  }

  ngOnInit() {
    let id = this.route.snapshot.paramMap.get("id");
    if (id) {
      this.busy = true;
      this.gearManagementService
        .getGearAdvice(id)
        .subscribe(advice => {
          this.advice = advice;
          this.headerImageURL = this.advice.headerImageURL;
          this.busy = false;
          this.getGearTypes(this.advice.bikeTypeID);
        });
    } else {
      this.advice = {
        languageCode: "EN",
        basicRecommendation: "",
        recommendationActive: false,
        title: "",
        headerImageURL: "",
        content: "",
        adviceactive: false,
        bikeTypeID:
          this.bikeTypes && this.bikeTypes.length > 0
            ? this.bikeTypes[0].value
            : 1,
        otherBikeTypes: []
      };
      this.headerImageURL = "";
      this.getGearTypes(this.advice.bikeTypeID);
    }
    console.log(this.contentEditor);
  }

  insertVideo() {
    this.advice.content += `<iframe width="100%" height="300" frameborder="0" src="https://www.youtube.com/embed/OmehC5MJDHE"></iframe>`;
  }

  otherBikeTypes() {
    return this.bikeTypes.filter(x => {
      return x.value !== this.advice.bikeTypeID;
    });
  }

  myUploader(event) {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      this.advice.headerImageURL = reader.result
        .toString()
        .replace(/^data:(.*;base64,)?/, "");
      this.headerImageURL = reader.result.toString();
    };
  }

  SaveAdvice() {
    this.saving = true;

    this.gearManagementService.postGearAdvice(this.advice).subscribe(
      result => {
        this.saving = false;
        this.router.navigateByUrl("/administration/bike-gear-advices");
      },
      err => {
        this.messageService.add({
          detail: "There was a problem saving this advice...",
          life: 5000
        });
        this.saving = false;
      }
    );
  }

  DeleteAdvice() {
    this.saving = true;
    this.gearManagementService.removeGearAdvice(this.advice).subscribe(
      result => {
        this.saving = false;
        this.router.navigateByUrl("/administration/bike-gear-advices");
      },
      err => {
        this.messageService.add({
          detail: "There was a problem deleting this advice...",
          life: 5000
        });
        this.saving = false;
      }
    );
  }

  valid() {
    var valid = true;
    valid =
      this.advice.bikeTypeID &&
      this.advice.gearTypeID &&
      this.advice.languageCode;
    if (!valid) return false;

    valid =
      (this.advice.recommendationActive &&
        this.advice.basicRecommendation.length > 0) ||
      !this.advice.recommendationActive;
    if (!valid) return false;

    valid =
      (this.advice.adviceActive &&
        this.advice.title.length > 0 &&
        this.advice.headerImageURL.length > 0 &&
        this.advice.content.length > 0) ||
      !this.advice.adviceActive;
    if (!valid) return false;

    return valid;
  }
}
